import React from 'react';
import {
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Stack,
} from '@mui/material';
import { Search as SearchIcon } from '@mui/icons-material';
import { DimensionItem } from '../../../../services/WorkflowService';

interface WorkflowListFiltersProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  triggerFilter: string;
  onTriggerFilterChange: (value: string) => void;
  statusFilter: string;
  onStatusFilterChange: (value: string) => void;
  workflowTriggers: DimensionItem[];
  loadingTriggers: boolean;
}

const WorkflowListFilters: React.FC<WorkflowListFiltersProps> = ({
  searchTerm,
  onSearchChange,
  triggerFilter,
  onTriggerFilterChange,
  statusFilter,
  onStatusFilterChange,
  workflowTriggers,
  loadingTriggers,
}) => (
  <Stack direction="row" spacing={2} sx={{ mb: 3 }}>
    <TextField
      placeholder="Search workflows..."
      value={searchTerm}
      onChange={(e) => onSearchChange(e.target.value)}
      size="small"
      sx={{ flex: 1 }}
      InputProps={{
        startAdornment: <SearchIcon sx={{ color: '#64748b', mr: 1 }} />,
      }}
    />
    <FormControl size="small" sx={{ minWidth: 200 }}>
      <InputLabel>Trigger Type</InputLabel>
      <Select
        value={triggerFilter}
        label="Trigger Type"
        onChange={(e) => onTriggerFilterChange(e.target.value)}
        disabled={loadingTriggers}
      >
        <MenuItem value="all">All Triggers</MenuItem>
        {workflowTriggers.map((trigger) => (
          <MenuItem key={trigger.value} value={trigger.value}>
            {trigger.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
    <FormControl size="small" sx={{ minWidth: 150 }}>
      <InputLabel>Status</InputLabel>
      <Select
        value={statusFilter}
        label="Status"
        onChange={(e) => onStatusFilterChange(e.target.value)}
      >
        <MenuItem value="all">All Status</MenuItem>
        <MenuItem value="active">Active</MenuItem>
        <MenuItem value="inactive">Inactive</MenuItem>
      </Select>
    </FormControl>
  </Stack>
);

export default WorkflowListFilters;
